// src/components/fundDetailsPage/analysisPanel/AnalysisPanelTablet/AnalysisPanelTablet.jsx

import { useState } from "react";

import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  GridItem,
  Heading,
  Text,
} from "@chakra-ui/react";

import { CustomElement } from "@/components/ui/box/CustomElement";
import { useActions } from "@/hooks/useActions";
import { h_400_12_135_48, h_700_14_120_28 } from "@/styles/fontStyles";

import { switchTag, switchValueAdd } from "../AnalysisPanel";
import ChartFund_1 from "../chartFund/ChartFund_1";

function AnalysisPanelTablet(data, handleTabClick, variant) {
  const defaultCardData = data?.data?.listParams[0] || {};
  const [selectedCard, setSelectedCard] = useState(defaultCardData);
  const {  setSelectedCardAnalyzeFund } =
    useActions();

  const styleVariant = (isSelected) => ({
    p: "12px",
    borderRadius: "10px",
    _hover: "unset",
    cursor: "pointer",
    h: "fit-content",
    w: "full",
    ...(isSelected
      ? {
          bg: "gray.200",
          border: "1px solid",
          borderColor: "gray",
        }
      : variant === "main"
      ? {
          bg: "menuSearchColor",
          border: "1px solid",
          borderColor: "gray",
        }
      : {
          bg: "white",
          boxShadow: "0px 0px 10px 0px rgba(200, 200, 200, 0.25)",
        }),
  });

  const handleTabClickInternal = (item) => {
    setSelectedCard(item);
    setSelectedCardAnalyzeFund(item);
  };

  return (
    <>
      <Accordion p={0} defaultIndex={[0]}>
        <AccordionItem p={0} defaultIndex={[0]}>
          <h2>
            <GridItem area={"listParams"}>
              {data?.data?.listParams.map((item, index) => {
                const isSelected = selectedCard === item;
                return (
                  // eslint-disable-next-line react/jsx-key
                  <>
                    {!item?.secondValue?.includes("Invalid Date") ? (
                      <AccordionItem
                        key={`${item?.title}-${index}`}
                        p={0}
                        defaultIndex={[0]}
                      >
                        <AccordionButton>
                          <CustomElement
                            variant={"whiteBtn"}
                            customStyle={styleVariant(isSelected)}
                            handler={() => handleTabClickInternal(item, index)}
                          >
                            {" "}
                            <Flex
                              flexDir={"column"}
                              w={"full"}
                              gap={"6px"}
                              //   height={"100%"}
                            >
                              <Flex justify={"space-between"} align={"center"}>
                                <Heading
                                  as={"h3"}
                                  {...h_700_14_120_28}
                                  color={"mainBlue"}
                                >
                                  {item?.title}
                                </Heading>

                                <Flex align={"flex-start"}>
                                  <Text
                                    color={"blue"}
                                    {...h_700_14_120_28}
                                    textAlign={"right"}
                                    pt={"3px"}
                                  >
                                    {item?.value}
                                  </Text>
                                  {item?.valueAdd &&
                                    switchValueAdd(item?.valueAdd)}
                                </Flex>
                              </Flex>
                              <Flex justify={"space-between"} align={"center"}>
                                <Text
                                  {...h_400_12_135_48}
                                  color={"gray"}
                                  pt={"3px"}
                                >
                                  {item?.secondValue}
                                </Text>
                                {item?.statusTag ? (
                                  <CustomElement
                                    variant={switchTag(item?.statusTag).variant}
                                    title={switchTag(item?.statusTag).title}
                                  />
                                ) : item?.statusText ? (
                                  <Text
                                    {...h_400_12_135_48}
                                    color={"gray"}
                                    pt={"3px"}
                                  >
                                    {item?.statusText}
                                  </Text>
                                ) : (
                                  <Box></Box>
                                )}
                              </Flex>
                            </Flex>
                          </CustomElement>
                        </AccordionButton>
                        <AccordionPanel p={0} pb={4}>
                          <Box>{isSelected && <ChartFund_1 />}</Box>
                        </AccordionPanel>
                      </AccordionItem>
                    ) : null}
                  </>
                );
              })}
            </GridItem>
          </h2>
        </AccordionItem>
      </Accordion>
    </>
  );
}

export default AnalysisPanelTablet;
